import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import './ErrorPage.css'; 

const ErrorPage = () => {

  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/'); 
  };

  return (
    <div className="error-page">
        <div className="error-container">
            <h1>Oops! Qualcosa è andato storto.</h1>
            <p>Non possiamo caricare la pagina che stai cercando. Per favore prova di nuovo più tardi.</p>
            <div className="error-actions">
                <button onClick={goToHome} className="btn-primary">Vai alla pagina principale</button>
                <button onClick={() => window.location.reload()} className="btn-secondary">Prova di nuovo</button>
            </div>
        </div>
    </div>
  );

};

export default ErrorPage;